(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AddConditionDeleteController',AddConditionDeleteController);

    AddConditionDeleteController.$inject = ['$uibModalInstance', 'entity', 'AddCondition'];

    function AddConditionDeleteController($uibModalInstance, entity, AddCondition) {
        var vm = this;
        vm.addCondition = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            AddCondition.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
